import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ENewAnswerModalStep } from '../../types/newAnswer';

export enum EStepActionTypes {
  Set = 'NEW_ANSWER/STEP/SET',
}

export type TSetStep = ITypedReduxAction<EStepActionTypes.Set, ENewAnswerModalStep>;

export type TNewAnswerFormStepActions = TSetStep;

/**
 * Redux action, который вызывает устанавливает шаг формы
 */
export const setNewAnswerFormStep: (step: ENewAnswerModalStep) => TSetStep = actionGenerator<
  EStepActionTypes.Set,
  ENewAnswerModalStep
>(EStepActionTypes.Set);
